import React from 'react';
import {
  required,
} from 'react-admin';

import {
  Grid,
  Typography,
} from '@mui/material';

import InfoPopover from '../../layout/InfoPopover';
import SelectInput from '../../layout/inputFields/SelectInput';

import { priorityChoices } from '../../../constants/thresholdPriorities';

const PriorityParameters = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography variant="label">Threshold priority</Typography>
      </Grid>
      <Grid size={12}>
        <SelectInput
          source="ruleParameters.parameterPriority"
          label="Threshold Priority"
          fullWidth
          choices={priorityChoices}
          popups={(
            <InfoPopover key="threshold priority" title="Threshold priority" content={'Given no override parameters, set prioritization of parameters. \n If no KYC form found, parameters will adapt the default values.'} />
          )}
          validate={required()}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default PriorityParameters;
